import React from 'react';
import styled from 'styled-components';

import {GOTHAM_MEDIUM, PT_SERIF} from '../../styles/typography'
import { mediaMax } from '@styles/sizes';

import Button from '../Button/Button'

const StyledPanel = styled.div`
  padding: 32px;
  font-size: 16px;
  margin: 0 16px;
  display: flex;
  flex-direction: column;
`;

export const PanelRow = styled.div`
  display: flex;
  margin-left: -16px;
  margin-right: -16px;
  ${mediaMax.tablet`
    flex-direction: column;
` }
`

export const PanelTitle = styled.h2`
  font-family: ${GOTHAM_MEDIUM};
  font-size: 28px;
  margin-bottom: 20px;
`;

export const PanelDescription = styled.p`
  margin-bottom: 20px;
`;

const StyledReadMore = styled(Button)`
  margin-top: auto;
  font-family: ${PT_SERIF};
  text-decoration: none;
  color: #000000;
`

export const PanelReadMore = ({url}) => {
  return(
    <StyledReadMore to={url}>Read More</StyledReadMore>
  )
}

export default StyledPanel;